// AutoHQ Care+ headline A/B test.
// - Random 50/50 assignment on first visit, persisted in localStorage.
// - Force a variant via ?v=a or ?v=b URL param (useful for pinning a creative to a variant).
// - Variant is read inside pixel.js (`_variant()`) and attached to every conversion event
//   under `experiment_variant` (GA4) and `variant` (Meta Pixel + CAPI custom_data).

const KEY = "autohq_ab_cp_headline";
export const VARIANTS = ["a", "b"];

export function getOrAssignVariant() {
  if (typeof window === "undefined") return "a";
  const forced = new URLSearchParams(window.location.search).get("v");
  if (forced && VARIANTS.includes(forced.toLowerCase())) {
    const v = forced.toLowerCase();
    localStorage.setItem(KEY, v);
    return v;
  }
  const saved = localStorage.getItem(KEY);
  if (saved && VARIANTS.includes(saved)) return saved;
  const v = VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
  localStorage.setItem(KEY, v);
  return v;
}

export function currentVariant() {
  if (typeof window === "undefined") return "a";
  return localStorage.getItem(KEY) || "a";
}
